<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Documents</span>
            <el-button class="white-btn" size="small" @click="dialogUpload=true" >Upload Document</el-button>
        </template>
        <el-row class="row" v-for="(group,index) in enquiry.groupattachments">
            <el-col>
                <span class="text-bold"> {{index}} - </span>
                <el-dropdown v-for="attachment in group" size="small" class="ml-2 mb-2" split-button type="primary" @click="viewfile(attachment.link)">
                    {{attachment.filename}}
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item @click="deletefile(attachment)">Delete</el-dropdown-item>

                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </el-col>
        </el-row>
    </el-card>

    <el-dialog
        v-model="dialogDelete"
        title="Delete Document?"
        width="500"
    >
        <span class="text-bold"> {{deleteattach.type}} - </span>
         <el-button size="small" type="primary" @click="viewfile(deleteattach.link)"> {{deleteattach.filename}}</el-button>

        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" :disabled="deleting" @click="dialogDelete = false">Cancel</el-button>
                <el-button type="primary" :disabled="deleting" :loading="deleting" @click="deleteattch()">
                    Confirm
                </el-button>
            </div>
        </template>
    </el-dialog>

    <el-drawer  v-model="dialogUpload" direction="rtl">
        <template #header>
            <h4>Upload Document</h4>
        </template>
        <template #default>
            <el-form
                ref="ruleFormRef"
                :model="form"
                status-icon
                :rules="rules"
                label-width="auto"
                class="demo-ruleForm"
                label-position="top"

            >

                <el-form-item label="Source" prop="type" >
                    <Select2   v-model="form.type" style="width:100%"  :settings="documenttypesajax" required/>

                </el-form-item>

                <el-form-item label="File" prop="file">
                    <input type="file"  @change="form.file=$refs.documentfile.files[0]"     ref="documentfile"   placeholder="Source" />

                </el-form-item>



            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogUpload=false">Cancel</el-button>
                <el-button type="primary" @click="submitForm()" :loading="uploading" :disabled="uploading">Upload</el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>
import {
    ElRow,ElCol,ElCard,ElDropdownItem,ElDropdownMenu,ElDropdown,ElDialog,ElButton,ElDrawer,ElForm,ElFormItem,ElInput
} from 'element-plus'
import $ from "jquery";

export default {
    name: "BookingDocuments",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { ElRow,ElCol,ElCard,ElDropdownItem,ElDropdownMenu,ElDropdown,ElDialog,ElButton,ElForm,ElDrawer,ElFormItem,ElInput },
    data() {
        return {
            dialogDelete:false,
            deleteattach:null,
            deleting:false,
            uploading:false,
            dialogUpload:false,
            documenttypesajax: {
                ajax: {
                    url: '/api/getdocumenttypes',
                    dataType: 'json',
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    id: item.id
                                }
                            })
                        };
                    },
                    cache: true
                }
            },
            form:{
                type:'',
                file:''
            },
            rules:{
                type:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                file:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
            }
        }
    },
    created(){

    },
    methods:{
        viewfile(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        },
        deletefile(attach){
                this.dialogDelete=true;
                this.deleteattach=attach;

        },
        deleteattch(){

            let currentObj = this;
            currentObj.deleting=true;
            axios.post('/booking/deletedocument/?eid='+this.enquiry.id,this.deleteattach).then(function (response) {

                toastr.success('Document Deleted Succesfully.');
                currentObj.$emit("saved");
                currentObj.deleting=false;
                currentObj.dialogDelete=false;
            })
                .catch(function (error) {
                    currentObj.deleting=false;
                    toastr.error('Something Wrong try again.');
                });
        },
        submitForm(){
            const formEl=this.$refs.ruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.uploaddocument()
                } else {
                    return false
                }
            })


        },
        uploaddocument(){
            const headers = { 'Content-Type': "multipart/form-data" };
            const formData = new FormData();
            formData.append('file',this.form.file);
            formData.append('type',this.form.type);

            let currentObj = this;
            currentObj.uploading=true;
            axios.post('/enquiry/uploaddocument?id='+this.enquiry.id,formData, { headers }).then(function (response) {
                toastr.success('Document Uploaded Succesfully.');
                currentObj.$emit("saved");
                currentObj.uploading=false;
                currentObj.dialogUpload=false;
            })
                .catch(function (error) {
                    if(error.response.status=="404"){
                        toastr.error(error.response.data);
                    }
                    else{
                        toastr.error('Something Wrong try again.');
                    }
                    currentObj.uploading=false;
                });
        },
    }
}
</script>

<style scoped>

</style>
